{
  "actions": "Veiksmai",
  "actionsAvailable": "Galimi veiksmai.",
  "clearSelection": "Išvalyti pasirinkimą",
  "selected": "Pasirinkta: {count}",
  "selectedAll": "Pasirinkta viskas"
}
